module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Design/Patch-fe2351c523cf12615c75b6d7b7720ed8.svg";